import {$,} from "../../core/js/Dom.ts";
import {initNotes, initNotesForm} from "../../core/js/Notes.ts";

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.dataset.url?.startsWith("page_note_precription")) {
        initState()
    }
})

function initState() {
    const target = $("#container-note-prescription")!
    initNotesForm(target)
    initNotes(target)
}